export const InstrumentationLog = ({ instrumentation, constants }) => ({
  SetUpConversionClicked: (hasCoupons) => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', `Set up conversions is clicked ${hasCoupons ? 'with coupons' : 'without coupons'}`);
  },
  CouponIsShown: () => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', 'Coupon is shown - setup page');
  },
  NoCoupon: () => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', 'No Coupon - setup page');
  },
  ManageConversionsClicked: () => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', 'Manage conversions is clicked');
  },
  SeeAllClicked: (errorType) => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', `See all is clicked for type ${errorType}`);
  },
  GridNameClicked: (category) => {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'conversion-tracking-card', `Grid name is clicked for type ${category}`);
  },
  Error: (response) => {
    instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'conversion-tracking-card-error', response);
  },
});
